import React from 'react'

const Dashboard = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Welcome 👋</h2>
      <p className="text-gray-600">
        This is your admin dashboard overview.
      </p>
    </div>
  );
};

export default Dashboard